import { useEffect, useState } from 'react';

type ImageNaturalSizeState = {
  width: number;
  height: number;
};

export function useImageNaturalSize(src: string) {
  const [size, setSize] = useState<ImageNaturalSizeState>({
    width: 0,
    height: 0,
  });

  useEffect(() => {
    let cancelled = false;
    const image = new Image();

    image.onload = () => {
      if (cancelled) {
        return;
      }

      setSize((previousSize) => {
        if (previousSize.width === image.naturalWidth && previousSize.height === image.naturalHeight) {
          return previousSize;
        }

        return {
          width: image.naturalWidth,
          height: image.naturalHeight,
        };
      });
    };
    image.src = src;

    return () => {
      cancelled = true;
    };
  }, [src]);

  return size;
}
